module.exports = __webpack_public_path__ + "img/list-metadata.27250ecd.png";